export const setErrorMessage = (data) => ({
  type: 'SET_ERROR_MESSAGE',
  data
})

export const clearErrorMessage = (data) => ({
  type: 'CLEAR_ERROR_MESSAGE',
  data
})
